module.exports = __webpack_public_path__ + "img/HowItWorks-ProtectYourEstate.48270b99.jpg";